import { StorageSerializers, useSessionStorage } from "@vueuse/core";
import { TenantRegistrationResource } from "@/modules/centralWebsite/tenantRegistration/types";

export const useTenantRegistrationStorage = () =>
  useSessionStorage<Partial<TenantRegistrationResource> | null>(
    "tenantRegistration",
    null,
    { serializer: StorageSerializers.object },
  );

export const useTenantOnboardingIdStorage = () =>
  useSessionStorage<string | null>("tenantOnboardingId", null);
